module.exports = __webpack_public_path__ + "img/collB_s.b07a9ce3.png";